(function () {
'use strict';

angular.module('hyresgastApp').controller('SelectAgreementPropertiesCtrl', SelectAgreementPropertiesCtrl);

function SelectAgreementPropertiesCtrl($scope, $route, $routeParams, $location,
  Negotiation, Agreement,
  Limits,
  Flash, ErrorHandler) {
  var vm = this;
  vm.Limits = Limits;

  vm.agreement = {
    negotiationId: $routeParams.negotiationId,
    id: $routeParams.id,
    documents: [],
    name: '', // there is a not null constraint on api
    isAllPropertiesSelected: true,
  };

  vm.pageLimit = 20;

  vm.tableColumns = [
    { title: 'Fastigheter', column: 'propertyDesignation' },
    { title: 'Kommun', column: 'municipality' },
    { title: 'LM distrikt', column: 'district' },
    { title: 'Antal lägenheter', column: 'numNegotiatedApartments' }
  ];

  vm.tableFGetData = () => {
    // eslint-disable-next-line no-undef
    return new Promise(resolve => {
      Negotiation.queryPropertyBySelection({
        id: $routeParams.negotiationId,
        include: ['owners']
      }, {
        unassigned: true,
        selectedDistrictIds: {},
        isAllDistrictsSelected: true,
      }).$promise.then(function (response) {
        resolve(response);
      }).catch(new ErrorHandler('Misslyckades att hämta fastigheter.'))
    });
  }

  vm.properties = [];

  vm.save = () => {
    vm.saving = true;
    vm.agreement.selectedPropertyIds = Object.fromEntries(vm.properties.map(p => [p.id, true]));
    Agreement.saveProperty(vm.agreement)
      .$promise.then(
        // eslint-disable-next-line no-unused-vars
        function (response) {
          // keep it simple for now (instead of reseting all
          // variables reload the controller)
          $route.reload();

          Flash.set('Fastighetsbestånd har sparats', 'success');
        })
      .catch(new ErrorHandler('Misslyckades att spara fastighetsbestånd.'))
      .finally(function () {
        vm.saving = false;
        $location.search({});
        $location.path('/negotiations/' + $routeParams.negotiationId + '/agreements/' + $routeParams.id);
      });
  }
}
})();